/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * Product Offerings Actions
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.10.0
 */

import { createAction } from '../../modules/app/createAction';
import { IMegaPower } from '../PageSubscriberId/components/Info/types';
import {
    PRODUCT_OFFERING_CLEAR,
    PRODUCT_OFFERING_CREATE_INQUIRY_FAILURE,
    PRODUCT_OFFERING_CREATE_INQUIRY_START,
    PRODUCT_OFFERING_CREATE_INQUIRY_SUCCESS,
    PRODUCT_OFFERING_GET_SUBSCRIBERS_CHECK_LIST_ACTION,
    PRODUCT_OFFERING_GET_SUBSCRIBERS_CHECK_LIST_FAILURE,
    PRODUCT_OFFERING_GET_SUBSCRIBERS_CHECK_LIST_SUCCESS,
    PRODUCT_OFFERING_HANDLE_NEXT,
    PRODUCT_OFFERING_SAVE_STORAGE,
    PRODUCT_OFFERING_SET_MEGAPOWER,
    PRODUCT_OFFERING_SET_PARAMS,
    PRODUCT_OFFERING_SET_STEP_VALID,
    PRODUCT_OFFERING_START_VALIDATE,
    PRODUCT_SUBSCRIBERS_LIST_INIT_START,
} from './wizardProductOfferingsConstants';
import {
    IProductOfferingsSetMegaPowerAction,
    IProductOfferingsSetParamsActionPayload,
    IProductOfferingsSetStepValidPayload,
    IProductOfferingsSubscriberActivationItem,
    TProductOfferingClearAction,
    TProductOfferingsCreateInquiryAction,
    TProductOfferingsCreateInquiryFailure,
    TProductOfferingsCreateInquirySuccess,
    TProductOfferingsGetSubscribersCheckListAction,
    TProductOfferingsGetSubscribersCheckListFailure,
    TProductOfferingsGetSubscribersCheckListSuccess,
    TProductOfferingsHandleNextAction,
    TProductOfferingsSaveStorageAction,
    TProductOfferingsSetParamsAction,
    TProductOfferingsSetStepValidAction,
    TProductOfferingsStartValidateAction,
    TProductSubscribersListInitAction,
} from './wizardProductOfferingsTypes';

export const productOfferingsClearAction = (): TProductOfferingClearAction => createAction(PRODUCT_OFFERING_CLEAR);

export const productOfferingsSetParamsAction = (
    payload: IProductOfferingsSetParamsActionPayload,
): TProductOfferingsSetParamsAction => createAction(PRODUCT_OFFERING_SET_PARAMS, payload);

export const productOfferingsSetMegaPowerAction = (
    payload: Pick<IMegaPower, 'id'>,
): IProductOfferingsSetMegaPowerAction => createAction(PRODUCT_OFFERING_SET_MEGAPOWER, payload);

export const productOfferingsStartValidateAction = (): TProductOfferingsStartValidateAction =>
    createAction(PRODUCT_OFFERING_START_VALIDATE);

export const productOfferingsSetStepValidAction = (
    payload: IProductOfferingsSetStepValidPayload,
): TProductOfferingsSetStepValidAction => createAction(PRODUCT_OFFERING_SET_STEP_VALID, payload);

export const productSubscribersListInitAction = (): TProductSubscribersListInitAction =>
    createAction(PRODUCT_SUBSCRIBERS_LIST_INIT_START);

/*
 * -------------------------------------------
 *           Create inquiry
 * -------------------------------------------
 */

export const productOfferingsCreateInquiryAction = (): TProductOfferingsCreateInquiryAction =>
    createAction(PRODUCT_OFFERING_CREATE_INQUIRY_START);

export const productOfferingsCreateInquirySuccess = (payload: number): TProductOfferingsCreateInquirySuccess =>
    createAction(PRODUCT_OFFERING_CREATE_INQUIRY_SUCCESS, payload);

export const productOfferingsCreateInquiryFailure = (payload: string): TProductOfferingsCreateInquiryFailure =>
    createAction(PRODUCT_OFFERING_CREATE_INQUIRY_FAILURE, payload);

/*
 * -------------------------------------------
 *           HANDLE NEXT
 * -------------------------------------------
 */

export const productOfferingsHandleNextAction = (): TProductOfferingsHandleNextAction =>
    createAction(PRODUCT_OFFERING_HANDLE_NEXT);

/*
 * -------------------------------------------
 *           STORAGE
 * -------------------------------------------
 */

export const productOfferingsSaveStorageAction = (): TProductOfferingsSaveStorageAction =>
    createAction(PRODUCT_OFFERING_SAVE_STORAGE);

/*
 * -------------------------------------------
 *           BASKET
 * -------------------------------------------
 */

export const productOfferingsGetSubscribersCheckListAction = (): TProductOfferingsGetSubscribersCheckListAction =>
    createAction(PRODUCT_OFFERING_GET_SUBSCRIBERS_CHECK_LIST_ACTION);
export const productOfferingsGetSubscribersCheckListSuccess = (
    payload: IProductOfferingsSubscriberActivationItem[],
): TProductOfferingsGetSubscribersCheckListSuccess =>
    createAction(PRODUCT_OFFERING_GET_SUBSCRIBERS_CHECK_LIST_SUCCESS, payload);
export const productOfferingsGetSubscribersCheckListFailure = (
    payload: string,
): TProductOfferingsGetSubscribersCheckListFailure =>
    createAction(PRODUCT_OFFERING_GET_SUBSCRIBERS_CHECK_LIST_FAILURE, payload);
